var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "btn-group" },
    [
      _c(
        "router-link",
        {
          staticClass: "btn btn-outline-info mr-2 details",
          attrs: { to: _vm.detailsParams, tag: "button" }
        },
        [_vm._v(" Detalle ")]
      ),
      _vm._v(" "),
      _c(
        "router-link",
        {
          staticClass: "btn btn-outline-primary btn-sm mr-2 edit",
          attrs: { to: _vm.editParams, tag: "button" }
        },
        [_vm._v(" Editar ")]
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "btn btn-sm mr-1",
          attrs: { variant: "outline-danger" },
          on: {
            click: function($event) {
              return _vm.onDelete()
            }
          }
        },
        [_vm._v(" Eliminar ")]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }